﻿import { Component, Input, Output, EventEmitter, ElementRef, ViewChild} from "@angular/core";
import { Router } from "@angular/router";
import { DataTable } from "angular2-datatable";
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts  } from "angular-2-dropdown-multiselect";
import { ValidationMessage } from "../validation/validationMessage";
import { ValidationMessageType } from "../validation/validationMessageType";
import {DataService} from "../services/dataService";
import { Modal } from "../shared/dialog/dialog.component";
import { ModalService } from "../shared/dialog/dialog.service";
import { DocumentType } from "../models/documentType.model";
import { Document } from "../models/document.model";
import { KeyedCollection } from "../shared/dictionary/dictionary";
import * as moment from 'moment';

@Component({
    selector: "jax-uploaddocumentcomponent",
    templateUrl: "./uploaddocument.component.html"
})

export class UploadDocumentComponent {
    public data;
    public juveniledata;
    public notificationPartiesData;
    public MODAL_ID: string;
    public currentPage : string;
    public caseNumber: string;
    public caseID: number; 
    public date = new Date();
    public getDocumentCompleted: boolean;
    public sortBy = "UploadedDate";
    public sortOrder = "desc";
    public rowsOnPage = 10;
    public validationMessage: ValidationMessage;
    private userID: number;
    private currentUser: any;
    private submit: boolean;
    public istoplevelCheckBoxChecked: boolean;
    public myjson: any = JSON;
    public hearingOptions: IMultiSelectOption[] = [];
    public optionsModel: number[];
    public myOptions: IMultiSelectOption[];
    public mySettings: IMultiSelectSettings;
    public myTexts: IMultiSelectTexts ;
    public errorMessage : string;
    public isCompleted:boolean;
    public hasError : boolean;
    
    public documentTypes: DocumentType[] = [];
    public documenttype: DocumentType = new DocumentType();
    public document: Document = new Document();
    public processedResult = new KeyedCollection<boolean>();

    @ViewChild("toplevelCheckBox") private toplevelCheckBox: any;

    constructor(private dataService: DataService, private router: Router, private modalService: ModalService) {
        this.MODAL_ID = "uploaddocument";
        this.currentPage = "upload";
        this.istoplevelCheckBoxChecked = false;
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.userID = this.currentUser.UserId;
        }
        this.optionsModel = [];
        // Settings configuration
        this.mySettings = {
            enableSearch: false,
            //checkedStyle: "glyphicon",
            buttonClasses: "btn-block dropdown-multiselect-button form-control editor-focusable",
            containerClasses: "dropdown dropdown-inline dropdown-multiselect-container",
            itemClasses: "dropdown-multiselect-item dropdown-divider divider",
            dynamicTitleMaxItems: 1,
            displayAllSelectedText: false
    };

        // Text configuration
        this.myTexts = {
            checkAll: "Select all hearings",
            uncheckAll: "Unselect all hearings",
            checked: "Hearing selected",
            checkedPlural: "Hearings selected",
            searchPlaceholder: "Find hearing",
            searchEmptyResult: "No hearing found...",
            searchNoRenderText: "Type in search box to see results...",
            defaultTitle: "--Select Hearing(s)--",
            allSelected: "All hearing selected"
        };
    }

    public LoadDistributionPage() {
        if (this.data.length <= 0) {
            let message = new ValidationMessage();
            message.messageType = ValidationMessageType.Error;
            message.message = "No files in pending queue.";
            this.validationMessage = message;
        }
        else {
            this.currentPage = "distribution";
        }
    }

    public LoadUploadPage() {
        this.currentPage = "upload";
    }

    public SendDistribution() {
        let fileProcessCount: number = 0;
        let errorMessage: string;
        this.submit = true;
        this.validationMessage = new ValidationMessage();
        this.document.CaseID = String(this.caseID);
        this.document.UploadedByID = String(this.userID);
        this.notificationPartiesData = null;
        for (let d of this.data) {
            this.document.DocumentID = d.DocumentID;
            //Check if resubmitting , if yes then process only error document
            if (this.processedResult.Count() > 0) {
                var key = this.processedResult.Keys().find(p => p == d.DocumentID);
                if (this.processedResult.Keys().find(p => p == d.DocumentID) != undefined && this.processedResult.Item(key)) {
                    this.document.DocumentID = -1;
                }
                else {
                    this.processedResult.Remove(d.DocumentID);
                }
            }

            if (this.document.DocumentID > 0) {
                fileProcessCount = fileProcessCount + 1;
                this.dataService.post("document/distribute", JSON.stringify(this.document)).subscribe(resp => {
                    if (resp.Succeeded == "1") {
                        this.processedResult.Add(d.DocumentID, true);
                        this.notificationPartiesData =  JSON.parse(resp.NotifiedParties);
                    }
                    else {
                        this.processedResult.Add(d.DocumentID, false);                      
                    }
                    errorMessage = resp.Message;
                    if (this.data.length == this.processedResult.Count()) {
                        let message = new ValidationMessage();
                        if (this.processedResult.Values().find(p => p == false) != undefined) {
                            message.messageType = ValidationMessageType.Error;
                        }
                        else {
                            message.messageType = ValidationMessageType.Ok;
                        }
                        message.message = errorMessage;
                        this.validationMessage = message;
                    }
                });
            }
        }

        if (fileProcessCount <= 0) {
            let message = new ValidationMessage();
            message.message = "No pending document in queue to distribute.";
            message.messageType = ValidationMessageType.Error;
            this.validationMessage = message;
        }
    }
    

    public CaseSelect(caseNumber: string, caseID: number) {
        this.validationMessage = new ValidationMessage();
        if (this.caseID != caseID) {
            this.submit = false;
            this.caseNumber = caseNumber;
            this.caseID = caseID;
            this.currentPage = "upload";
            this.sortBy = "UploadedDate";
            this.sortOrder = "desc";
            this.getJuveniles();
            this.getDocumentTypes();
            this.getUnresultedHearings();   
        }
        if (this.toplevelCheckBox) {
            this.toplevelCheckBox.checked = false;
        }
        this.submit = false;
        this.checkAll(false);
        this.processedResult.Clear();
        this.getDocumentUploaded();
        this.notificationPartiesData = null;
    }

    public getDocumentTypes() {
        this.dataService.get("document/documenttypes").subscribe(resp => {
                this.documentTypes = resp;
                this.documentTypes.unshift(new DocumentType());
                this.documenttype.Id = -1;
            },
            (error) => {
                this.documentTypes.unshift(new DocumentType());
                this.documenttype.Id = -1;
            }
        );
    }

    public getUnresultedHearings() {
        this.optionsModel = [];
        this.hearingOptions = [];
        this.myOptions = [];
        this.dataService.get("cases/unresultedfuturehearings?caseId=" + this.caseID).subscribe(resp => {
                let res = resp;
                for (let result of res) {
                    let option = this.generateItem(result.CalendarEventId, moment(result.HearingDateTime).format("MM/DD/YYYY hh:mm A") + " - " + result.HearingType + " " + result.HearingSubType);
                    this.hearingOptions.push(option);
                }
                this.myOptions = this.hearingOptions;
            },
            (error) => {

            }
        );
    }

    public onChange() {
        console.log(this.optionsModel);
    }


    private generateItem(id, name): IMultiSelectOption  {
        return { id, name };
    }

    public getDocumentUploaded() {
        this.getDocumentCompleted = false;
        this.dataService.get("document/pendingdocument?caseID=" + this.caseID + "&userID=" + this.userID).subscribe(
            resp => {
                this.data = resp;
                this.getDocumentCompleted = true;
            },
            (error) => {
                this.getDocumentCompleted = true;
            }
        );
    }

    public getJuveniles() {
        this.dataService.get("document/juveniles?caseID=" + this.caseID).subscribe(resp => {
                this.juveniledata = resp;
                this.checkAll(false);
            },
            (error) => {
            }
        );
    }

    public fileSelected(event) {
        this.submit = false;
        this.getDocumentCompleted = false;
        this.notificationPartiesData = null;
        this.document.CaseID = String(this.caseID);
        this.document.UploadedByID = String(this.userID);
        this.document.DocumentTypeID = String(this.documenttype.Id);
        this.document.CalendarEvents = this.optionsModel;
        this.validationMessage = new ValidationMessage();
        let message = new ValidationMessage();
        let fileObject = event.target || event.srcElement;

        this.document.Juveniles = this.juveniledata.filter(obj => obj.Selected === true);

        if (this.document.Juveniles.length === 0) {
            message.message = "Please select at least one juvenile.";
            message.messageType = ValidationMessageType.Error;
            this.validationMessage = message;
            this.getDocumentCompleted = true;
        }
        else if (this.document.DocumentTypeID === "-1") {
            message.message = "Please select at document type.";
            message.messageType = ValidationMessageType.Error;
            this.validationMessage = message;
            this.getDocumentCompleted = true;
        }
        else if (fileObject.files && fileObject.files[0] && fileObject.files[0].type === "application/pdf" && fileObject.files[0].size <= 26355054 && fileObject.files[0].name.length<=75) {
            let formData = new FormData();
            //test
            formData.append('CaseID', (this.document.CaseID));
            formData.append("DocumentTypeID", (this.document.DocumentTypeID));
            formData.append("UploadedByID", (this.document.UploadedByID));
            formData.append("Juveniles", JSON.stringify((this.document.Juveniles)));
            formData.append("CalendarEvents", JSON.stringify((this.document.CalendarEvents)));
            formData.append("files[]", fileObject.files[0],fileObject.files[0].name);

            this.dataService.postWithFile("document/upload", formData).subscribe(
                resp => {
                    if (resp.Succeeded == 1) {
                        this.getDocumentUploaded();
                        message.messageType = ValidationMessageType.Ok;
                    } else {
                        message.messageType = ValidationMessageType.Error;
                    }
                    message.message = resp.Message;
                    this.validationMessage = message;
                    this.getDocumentCompleted = true;
                },
                (error) => {
                    message.message = error.message.Message || error.statusText || error.message;
                    message.messageType = ValidationMessageType.Error;
                    this.validationMessage = message;
                    this.getDocumentCompleted = true;
                });
        } else if (fileObject.files && fileObject.files[0] && fileObject.files[0].type !== "application/pdf") {
            message.message = "You can only upload pdf file.";
            message.messageType = ValidationMessageType.Error;
            this.validationMessage = message;
            this.getDocumentCompleted = true;
        }
        else if (fileObject.files[0].size > 26355054) {
            message.message = "File could not be uploaded. The file size is " + ((fileObject.files[0].size / 1024) / 1024).toFixed(2) + "MB, which exceeds the maximum file size of 25MB."  ;
            message.messageType = ValidationMessageType.Error;
            this.validationMessage = message;
            this.getDocumentCompleted = true;
        }
        else if (fileObject.files[0].name.length > 75) {
            message.message = "Document could not be uploaded.  The file name exceeds the maximum length of 75 characters.";
            message.messageType = ValidationMessageType.Error;
            this.validationMessage = message;
            this.getDocumentCompleted = true;
        }
        else {
            this.getDocumentCompleted = true;
        }
    }

   public removeItem(documentId: number) {
        this.validationMessage = new ValidationMessage();
        let message = new ValidationMessage();
        this.dataService.post("document/deletependingdocument?DocumentID=" + documentId).subscribe(
            (response) => {
                if (response.Succeeded == 1) {
                    message.messageType = ValidationMessageType.Ok;
                    let doc: any = this.data.find(p=>p.DocumentID===documentId);
                    if (doc !== undefined) {
                        let index = this.data.indexOf(doc);
                        if (index !== -1) {
                            this.data.splice(index, 1);
                        }
                    } 
                }
                else {
                    message.messageType = ValidationMessageType.Error;
                }
                message.message = response.Message;
                this.validationMessage = message;
            },
            (error) => {
            }
        );
    }

   public checkAll(ev) {
       if (this.juveniledata) {
           this.juveniledata.forEach(obj => obj.Selected = ev);   
       }
    }

    public topLevelChange(ev, toplevelCheckBox) {
        let checkedcount = this.juveniledata.filter(obj => obj.Selected === true).length;
        if (checkedcount === 0) {
            toplevelCheckBox.checked = false;
            toplevelCheckBox._checkbox.nativeElement.indeterminate = false;
        }
        else if (checkedcount < this.juveniledata.length) {
            toplevelCheckBox.checked = false;
            toplevelCheckBox._checkbox.nativeElement.indeterminate = true;
        } else {
            toplevelCheckBox.checked = true;
            toplevelCheckBox._checkbox.nativeElement.indeterminate = false;
        }
   }

    public openPdf(documentId: number, documentName: string) {
        this.dataService.sharedService.openPopupWindow();
        this.dataService.getPdf("document/pendingdocument?pendingDocumentId=" + documentId + "&documentName=" + documentName)
            .subscribe((res) => {
                    this.dataService.sharedService.displayPdf(res,documentName);
                },
                (error) => {
                    this.errorMessage = error.message;
                    this.isCompleted = true;
                    this.hasError = true;
                    this.dataService.sharedService.closePopupWindow();
                });
    }

}